import { Typography } from '@mui/material';
import { GridValidRowModel } from '@mui/x-data-grid-pro';
import { RestrictionCheck } from '@procureai/permissions-ui';
import { Multiline } from '@procureai/ui-mui';

import { CommodityLinkCell, CommodityLinkCellValue } from '../CommodityLinkCell/CommodityLinkCell';

export interface CommodityLinkWithDescriptionCellProps<R extends GridValidRowModel = any> {
  value: CommodityLinkCellValue;
  row?: R;
  to?: string;
  needs?: RestrictionCheck;
  description?: string;
}

export const CommodityLinkWithDescriptionCell = <R extends GridValidRowModel = any>({
  value,
  row,
  to,
  needs,
  description,
}: CommodityLinkWithDescriptionCellProps<R>) => {
  return (
    <div>
      {value && (
        <Typography variant="body2" color="textPrimary">
          <CommodityLinkCell to={to} needs={needs} value={value} row={row} />
        </Typography>
      )}
      {description && (
        <Typography variant="body2" color="textSecondary">
          <Multiline>{description}</Multiline>
        </Typography>
      )}
    </div>
  );
};
